module.exports = __webpack_public_path__ + "img/xt10@2x.45786bfb.png";